module.exports = __webpack_public_path__ + "img/brick_bump.18cbaac6.jpg";